export default "skymp5-front/62c6036ec23083cd43d571f7d1a573d9.png";